

















































































































































































































































import { Mixins, Component, Prop, Watch, Ref } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';
import * as U from '@/utils';

import AxAPI from '@/api';
import { TempEmployee, UserRegisterPageInfo } from '@/interfaces';

type Group = I.AxZone;

type PageInfo = I.MealSettingPageInfo;

type CardList = {};
type CashList = {};

type DataItem = U.DataItem<I.PacketTempGeneralIssue, State>;
type DataStore = U.DataStore<I.PacketTempGeneralIssue>;

type UpdateItemParam = I.PacketMealTimeUpdate;

const DataStore = U.DataStore;

class State {
  userid: number;
  empno: string;
  name: string;
  uid: string;
  telNo: string;
  email: string;
  accessZoneCode: number;
  companyCode: I.CodeData;
  deptCodeA: I.CodeData;
  deptCodeB: I.CodeData;
  dutyCodeA: I.CodeData;
  userType: I.CodeData;
  userStatus: I.CodeData;
  isAntipass: boolean;
  isAdmin: boolean;
  isEscort: boolean;
  periodFrom: Date;
  periodTo: Date;
  timeFrom: string;
  timeTo: string;
  listDoor: I.DoorAuthSendData[];
  listGroup: I.DoorAuthSendData[];
  tempCardNo: string;
  tempCardName: string;
  tempCompanyCode: string;
  tempCompanyName: string;
  tempDeptCodeA: string;
  tempDeptNameA: string;
  tempUserId: number;
  tempUpdateIndex: number;
  seqNo: number;
  gubun: string;
  constructor() {
    this.userid = -1;
    this.empno = '';
    this.name = '';
    this.uid = '';
    this.telNo = '';
    this.email = '';
    this.accessZoneCode = 0;
    this.companyCode = { code: '', name: '' };
    this.deptCodeA = { code: '', name: '' };
    this.deptCodeB = { code: '', name: '' };
    this.dutyCodeA = { code: '', name: '' };
    this.userStatus = { code: '1', name: '' };
    this.userType = { code: '4', name: '' };
    this.isAntipass = false;
    this.isAdmin = false;
    this.isEscort = false;
    this.periodFrom = new Date();
    this.periodTo = new Date(2050, 11, 31, 23, 59, 0);
    this.timeFrom = '';
    this.timeTo = '';
    this.listDoor = [];
    this.listGroup = [];
    this.tempCardNo = '';
    this.tempCardName = '';
    this.tempCompanyCode = '';
    this.tempDeptCodeA = '';
    this.tempCompanyName = '';
    this.tempDeptNameA = '';
    this.tempUserId = -1;
    this.tempUpdateIndex = 0;
    this.seqNo = -1;
    this.gubun = 'U';
  }
}

class DialogState<T extends I.DoorAuthSendData> {
  show: boolean;
  title: string;
  search: string;
  searchSelect: boolean;
  selected: T[];
  headers: unknown[];
  items: T[];
  zoneCode: number;
  callback: Function;

  onAdd(list: T[]) {
    list.forEach(item => {
      this.selected.push(item);
    });
  }

  onRemove(list: T[]) {
    list.forEach(item => {
      const find = this.selected.find(x => x.code === item.code);
      if (find) {
        const idx = this.selected.indexOf(find);
        if (idx > -1) {
          this.selected.splice(idx, 1);
        }
      }
    });
  }

  constructor() {
    this.show = false;
    this.title = '';
    this.search = '';
    this.searchSelect = false;
    this.selected = [];
    this.headers = [];
    this.items = [];
    this.zoneCode = 0;
    this.callback = async () => {};
  }
}

enum ECodeType {
  ECompanyCode,
  EDeptCodeA,
  EDeptCodeB,
  EDutyCodeA
}

class CodeDialogState {
  show: boolean;
  title: string;
  items: I.CodeData[];
  selected: unknown;
  search: string;
  headers: unknown[];
  codeType: ECodeType;
  callback: Function;

  constructor() {
    this.show = false;
    this.title = '';
    this.items = [];
    this.search = '';
    this.headers = [];
    this.callback = async () => {};
    this.codeType = ECodeType.ECompanyCode;
  }
}

abstract class BaseClass extends Mixins(AxPage) {
  API!: AxAPI;
  dataItem!: DataItem;
  state = new State();

  pageInfo?: UserRegisterPageInfo;
  listUserStatus: I.CodeData[] = [];
  listUserType: I.CodeData[] = [];
  dialogState = new DialogState();
  codeDialogState = new CodeDialogState();
  message = '';
  tabCard = 0;
  tabZone = 0;
}

interface BaseInterface extends BaseClass {}

@Component
class ApiHandler extends BaseClass {
  callback!: Function;

  async getPageInfo() {
    const result = await this.API.call.user.getRegisterPageInfo();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  makeTempGeneralPacket(): I.PacketTempGeneralIssue {
    return {
      seqNo: this.state.seqNo,
      tempUserId: this.dataItem.state.tempUserId,
      tempUpdateIndex: this.dataItem.state.tempUpdateIndex,
      tempName: this.dataItem.state.tempCardName,
      tempCompanyCode: this.dataItem.state.tempCompanyCode,
      tempCompany: this.dataItem.state.tempCompanyName,
      tempDivisionCode: this.dataItem.state.tempDeptCodeA,
      tempDivision: this.dataItem.state.tempDeptNameA,
      tempCardNo: this.state.tempCardNo,
      gubun: this.state.gubun,
      empno: this.dataItem.state.empno,
      name: this.dataItem.name,
      companyCode: this.state.companyCode,
      deptCodeA: this.state.deptCodeA,
      deptCodeB: this.state.deptCodeB,
      dutyCodeA: this.state.dutyCodeA,
      listGroup: this.state.listGroup,
      listDoor: this.state.listDoor,
      timeFrom: '',
      timeTo: '',
      email: this.state.email,
      telNo: this.state.telNo,
      isAdmin: false,
      isEscort: false,
      periodFrom: this.state.periodFrom,
      periodTo: this.state.periodTo
    };
  }

  async onSaveCard() {
    const packet = await this.makeTempGeneralPacket();
    console.log('packet', packet);
    if (!packet) return;
    this.setLoading(true);
    const result = await this.API.call.temp.tempGeneralSave(packet);
    this.setLoading(false);

    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      if ((this.state.gubun = 'U')) {
        await this.showErrorModal('정보', '저장 되었습니다.');
      } else {
        await this.showErrorModal('정보', '반납 되었습니다.');
      }

      return result;
    }
  }

  async onSaveClicked() {
    if (!this.state.name) {
      await this.showErrorModal('오류', '이름을 입력 해주세요.');
      return;
    }
    if (!this.dataItem.state.tempCardNo) {
      await this.showErrorModal('오류', '카드번호을 입력 해주세요.');
      return;
    }
    this.state.gubun = 'U';
    await this.onSaveCard();
    await this.callback();
    this.on = false;
  }

  async onReturnClicked() {
    if (!this.state.name) {
      await this.showErrorModal('오류', '이름을 입력 해주세요.');
      return;
    }
    if (!this.dataItem.state.tempCardNo) {
      await this.showErrorModal('오류', '카드번호을 입력 해주세요.');
      return;
    }
    this.state.gubun = 'R';
    await this.onSaveCard();
    await this.callback();
    this.on = false;
  }
}

@Component
class DataItemHandler extends BaseClass {
  dataItems: DataItem[] = [
    {
      name: '카드',
      store: {} as DataStore,
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[0];
  }
}

@Component
class DialogHandler extends BaseClass {
  showEmployeeSearchDialog() {
    type EmployeeSearchDialogParams = { param: I.DataParam };

    const dialogParams = new I.DialogParam<EmployeeSearchDialogParams>(
      'AxSearchTempEmployeeDialog',
      {
        param: {
          items: [],
          selected: [],
          callback: async () => {
            const selected = dialogParams.props.param.selected[0] as I.TempEmployee;
            if (!selected) return;
            console.log('select', selected);
            // this.dataItem.state.empno = selected.empno;
            // this.dataItem.state.name = selected.name;
            // this.dataItem.state.companyName = selected.companyName;
            // this.dataItem.state.deptNameA = selected.deptNameA;
            // this.dataItem.state.deptNameB = selected.deptNameB;
            // this.dataItem.state.dutyNameA = selected.dutyNameA;
            // this.dataItem.state.userTypeName = selected.userTypeName;
            // this.dataItem.state.userStatusName = selected.userStatusName;
            // this.dataItem.state.telNo = selected.telNo;
            // this.dataItem.state.email = selected.email;
            // this.dataItem.state.staffUserId = selected.userId;
            // this.dataItem.state.staffUpdateIndex = selected.updateIndex;
            // this.dataItem.state.periodFrom = new Date(selected.periodFrom);
            // this.dataItem.state.periodTo = new Date(selected.periodTo);
          }
        }
      }
    );
    this.showDialog(dialogParams);
  }

  showTempCardSearchDialog() {
    type TempCardSearchDialogParams = { param: I.DataParam };

    const dialogParams = new I.DialogParam<TempCardSearchDialogParams>('AxTempCardSearchDialog', {
      param: {
        items: [],
        selected: [],
        callback: async () => {
          const selected = dialogParams.props.param.selected[0] as I.TempEmployee;
          if (!selected) return;
          this.dataItem.state.tempCardNo = selected.cardNo;
          this.dataItem.state.tempCardName = selected.name;
          this.dataItem.state.tempCompanyCode = selected.companyCode;
          this.dataItem.state.tempCompanyName = selected.companyName;
          this.dataItem.state.tempDeptCodeA = selected.deptCodeA;
          this.dataItem.state.tempDeptNameA = selected.deptNameA;
          this.dataItem.state.tempUserId = selected.userId;
          this.dataItem.state.tempUpdateIndex = selected.updateIndex;
        }
      }
    });
    this.showDialog(dialogParams);
  }
}

@Component
class BaseData extends Mixins(AxPage) implements BaseInterface {
  dataItem!: DataItem;

  on = true;
  width = 1047;
  height = 800;

  state = new State();
  pageInfo?: UserRegisterPageInfo;
  listUserStatus: I.CodeData[] = [];
  listUserType: I.CodeData[] = [];
  dialogState = new DialogState();
  codeDialogState = new CodeDialogState();
  message = '';
  tabCard = 0;
  tabZone = 0;

  @Prop({ type: Function, default: () => {} })
  callback!: Function;

  @Prop({ type: Object, default: () => {} })
  generalList!: I.TempGeneralHistoryList;

  @Watch('on')
  onSwitchChanged() {
    this.$emit('changed', this.on);
  }

  get periodFrom() {
    return this.formatTime(this.state.periodFrom.toISOString(), 'YYYY-MM-DD');
  }

  set periodFrom(date: string) {
    this.state.periodFrom = new Date(date);
  }

  get periodTo() {
    return this.formatTime(this.state.periodTo.toISOString(), 'YYYY-MM-DD');
  }

  set periodTo(date: string) {
    this.state.periodTo = new Date(date);
  }

  @Ref()
  fileUpload!: HTMLInputElement;

  TabZoneChange(value: number) {
    const list = this.getZoneList();
    if (list) {
      this.state.accessZoneCode = list[value].code;
    }
  }

  ClickOpenGroupPriv() {
    type GroupPrivParams = { title: string; param: I.DataParam };

    const listAllGroup = this.pageInfo?.listGroup.filter(
      x => x.zoneCode === this.state.accessZoneCode
    );
    if (!listAllGroup) return;

    const dialogParams = new I.DialogParam<GroupPrivParams>('AxDeviceSelectDialog', {
      title: '출입문 그룹 선택',
      param: {
        items: listAllGroup,
        selected: [],
        callback: async () => {
          const selected = dialogParams.props.param.selected as I.DoorAuthSendData[];
          const remain = this.state.listGroup.filter(x => x.zoneCode !== this.state.accessZoneCode);

          console.log('출입문 그룹 callback', remain, selected);

          this.state.listGroup = [...remain, ...selected];
        }
      }
    });
    this.showDialog(dialogParams);
  }

  ClickOpenDoorPriv() {
    type GroupPrivParams = { title: string; param: I.DataParam };

    const listAllDoor = this.pageInfo?.listDoor.filter(
      x => x.zoneCode === this.state.accessZoneCode
    );
    if (!listAllDoor) return;

    const dialogParams = new I.DialogParam<GroupPrivParams>('AxDeviceSelectDialog', {
      title: '출입문 선택',
      param: {
        items: listAllDoor,
        selected: [],
        callback: async () => {
          const selected = dialogParams.props.param.selected as I.DoorAuthSendData[];
          const remain = this.state.listDoor.filter(x => x.zoneCode !== this.state.accessZoneCode);

          console.log('출입문 그룹 callback', remain, selected);

          this.state.listDoor = [...remain, ...selected];
        }
      }
    });
    this.showDialog(dialogParams);
  }

  onAdd(list: I.DoorAuthSendData[]) {
    this.dialogState.onAdd(list);
  }

  onRemove(list: I.DoorAuthSendData[]) {
    this.dialogState.onRemove(list);
  }

  ClickDoorSave() {
    this.dialogState.show = false;
    this.state.listDoor = [];
    this.dialogState.selected.forEach(item => {
      this.state.listDoor.push({
        code: item.code,
        name: item.name,
        zoneCode: item.zoneCode,
        zoneName: item.zoneName,
        scheduleCode: 0
      });
    });
  }

  ClickGroupSave() {
    this.dialogState.show = false;
    this.state.listGroup = [];
    this.dialogState.selected.forEach(item => {
      this.state.listGroup.push({
        code: item.code,
        name: item.name,
        zoneCode: item.zoneCode,
        zoneName: item.zoneName,
        scheduleCode: 0
      });
    });
  }

  onDialogRowClicked(item: never) {
    this.codeDialogState.selected = item;
  }

  upload() {
    this.fileUpload.click();
  }

  async getBaseData() {
    const result = await this.API.call.user.getRegisterPageInfo();
    console.log('prepare', result);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async closeDialog() {
    console.log('close dialog');
    this.codeDialogState.show = false;
    this.dialogState.show = false;
    await this.dialogState.callback();

    // 애니메이션 트랜지션이 끝나고나서 Dialog가 초기화되어야 하므로
    setTimeout(() => {
      this.dialogState = new DialogState();
      this.codeDialogState = new CodeDialogState();
      if (this.pageInfo) {
        // this.pageInfo.listDoor.forEach(item => {
        //   this.dialogState.items.push({
        //     code: item.code,
        //     name: item.name,
        //     zoneCode: item.zoneCode,
        //     zoneName: item.zoneName
        //   });
        // });
      }
    }, 100);
  }
  CodeSelect() {
    if (this.codeDialogState.codeType === ECodeType.ECompanyCode) {
      this.state.companyCode = (this.codeDialogState.selected as I.CodeData[])[0];
    } else if (this.codeDialogState.codeType === ECodeType.EDeptCodeA) {
      this.state.deptCodeA = (this.codeDialogState.selected as I.CodeData[])[0];
    } else if (this.codeDialogState.codeType === ECodeType.EDeptCodeB) {
      this.state.deptCodeB = (this.codeDialogState.selected as I.CodeData[])[0];
    } else if (this.codeDialogState.codeType === ECodeType.EDutyCodeA) {
      this.state.dutyCodeA = (this.codeDialogState.selected as I.CodeData[])[0];
    }
    this.closeDialog();
  }

  showCompanySelectDialog() {
    if (!this.pageInfo) return;

    this.showCodeSelectDialog({
      title: '회사 검색',
      param: {
        items: this.pageInfo.listCompanyCode,
        selected: [this.state.companyCode],
        callback: async (selected: I.CodeData[]) => {
          if (selected.length) {
            this.state.companyCode = selected[0];
          } else {
            this.state.companyCode = { code: '', name: '' };
          }
        }
      },
      single: true
    });
  }

  showDeptCodeASelectDialog() {
    if (!this.pageInfo) return;

    this.showCodeSelectDialog({
      title: '사업장 검색',
      param: {
        items: this.pageInfo.listDeptCodeA,
        selected: [this.state.deptCodeA],
        callback: async (selected: I.CodeData[]) => {
          if (selected.length) {
            this.state.deptCodeA = selected[0];
          } else {
            this.state.deptCodeA = { code: '', name: '' };
          }
        }
      },
      single: true
    });
  }

  showDeptCodeBSelectDialog() {
    if (!this.pageInfo) return;

    this.showCodeSelectDialog({
      title: '부서 검색',
      param: {
        items: this.pageInfo.listDeptCodeB,
        selected: [this.state.deptCodeB],
        callback: async (selected: I.CodeData[]) => {
          if (selected.length) {
            this.state.deptCodeB = selected[0];
          } else {
            this.state.deptCodeB = { code: '', name: '' };
          }
        }
      },
      single: true
    });
  }

  showDutyCodeASelectDialog() {
    if (!this.pageInfo) return;

    this.showCodeSelectDialog({
      title: '직급 검색',
      param: {
        items: this.pageInfo.listDutyCodeA,
        selected: [this.state.dutyCodeA],
        callback: async (selected: I.CodeData[]) => {
          if (selected.length) {
            this.state.dutyCodeA = selected[0];
          } else {
            this.state.dutyCodeA = { code: '', name: '' };
          }
        }
      },
      single: true
    });
  }

  OpenCodePopup(type: string) {
    if (type === 'companycode') {
      if (!this.pageInfo) return;

      this.showCodeSelectDialog({
        title: '사업장 검색',
        param: {
          items: this.pageInfo.listCompanyCode,
          selected: [this.state.companyCode],
          callback: async (selected: I.CodeData) => {
            this.state.companyCode = selected;
          }
        },
        single: true
      });
      return;
    }
    if (this.pageInfo == null) return;
    const headers = [{ text: '이름', value: 'name', align: 'start' }];
    this.codeDialogState.headers = headers;
    let list: I.CodeData[] = [];
    let title = '';
    let codeType: ECodeType = ECodeType.ECompanyCode;
    if (type === 'companycode') {
      list = this.pageInfo.listCompanyCode;
      title = '회사 검색';
      codeType = ECodeType.ECompanyCode;
    } else if (type === 'deptcodea') {
      list = this.pageInfo.listDeptCodeA;
      title = '사업장 검색';
      codeType = ECodeType.EDeptCodeA;
    } else if (type === 'deptcodeb') {
      list = this.pageInfo.listDeptCodeB;
      title = '부서 검색';
      codeType = ECodeType.EDeptCodeB;
    } else if (type === 'dutycodea') {
      list = this.pageInfo.listDutyCodeA;
      title = '직급 검색';
      codeType = ECodeType.EDutyCodeA;
    }
    this.codeDialogState.items = list;
    this.codeDialogState.show = true;
    this.codeDialogState.title = title;
    this.codeDialogState.codeType = codeType;
    this.codeDialogState.callback = this.CodeSelect;
  }
}

const Handlers = Mixins(Mixins(ApiHandler, DataItemHandler, DialogHandler));

@Component
export default class AxTempGeneralReturnDialog extends Mixins(BaseData, Handlers) {
  async prepare() {
    this.state.seqNo = this.generalList.seqNo;
    this.state.name = this.generalList.targetName;
    this.state.empno = this.generalList.targetEmpno;
    this.state.companyCode.code = this.generalList.targetCompanyCode;
    this.state.companyCode.name = this.generalList.targetCompanyName;
    this.state.deptCodeA.code = this.generalList.targetDivisionCode;
    this.state.deptCodeA.name = this.generalList.targetDivisionName;
    this.state.deptCodeB.code = this.generalList.targetDeptCode;
    this.state.deptCodeB.name = this.generalList.targetDeptName;
    this.state.dutyCodeA.code = this.generalList.targetDutyCode;
    this.state.dutyCodeA.name = this.generalList.targetDutyName;
    this.state.telNo = this.generalList.targetPhone;
    this.state.email = this.generalList.targetEmail;
    this.dataItem.state.tempCardNo = this.generalList.tempCardNo;
    this.dataItem.state.tempCompanyCode = this.generalList.tempCompanyCode;
    this.dataItem.state.tempCompanyName = this.generalList.tempCompany;
    this.dataItem.state.tempDeptCodeA = this.generalList.tempDivisionCode;
    this.dataItem.state.tempDeptNameA = this.generalList.tempDivision;
    this.dataItem.state.tempCardName = this.generalList.tempName;
    this.dataItem.state.tempUserId = this.generalList.tempUserID;
    this.dataItem.state.tempUpdateIndex = this.generalList.tempUpdateIndex;
    this.dataItem.state.periodFrom = new Date(this.generalList.targetPeriodFrom);
    this.dataItem.state.periodTo = new Date(this.generalList.targetPeriodTo);

    const result = await this.API.call.temp.tempByUserId(this.generalList.tempUserID);
    if (result instanceof Error) {
      await this.handleError(result);
    } else {
      this.state.listGroup = result.data.listGroup;
      this.state.listDoor = result.data.listDoor;
    }

    const pageInfo = await this.getPageInfo();
    if (pageInfo) {
      this.pageInfo = pageInfo;
      this.listUserStatus = pageInfo.listUserStatus;
      this.listUserType = pageInfo.listUserType;
      if (this.pageInfo) {
        const list = this.getZoneList();
        if (list) {
          this.state.accessZoneCode = list[0].code;
        }
      }
    }
  }

  upload() {
    console.log('upload');
  }
}
